import {create} from 'zustand'
import {devtools, persist} from 'zustand/middleware'
import * as React from "react";

type Store = {
  careInfo: {
    height: number, weight: number, bmi: number, interest_disease: string, work_strength: string, goal: number, food: number, reset: string
  }
}

const useStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        careInfo: {height: 0, weight: 0, bmi: 0, interest_disease: '', work_strength: '', goal: 0, food: 0, reset: ''},
        setCareInfo: (name: any, value: any) => set((state: any) => {
          state.careInfo[name] = value;
          return {}
        }),
      }),
      { name: 'careStore' },
    ),
  ),
)

export default useStore;